module.exports = __webpack_public_path__ + "img/education.af1b6e88.jpg";